import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import { Datenschutz } from './Datenschutz';
import { Impressum } from './Impressum';
// import StudioErstellen from './components/StudioErstellen/StudioErstellen';
// import { StudioErstellenProvider } from './store/studioErstellenStore';

function App() {
  return (
    <BrowserRouter basename="/promo">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/impressum" element={<Impressum />} />
        {/* <StudioErstellenProvider> */}
          {/* <Route path="/studio-erstellung/*" element={<StudioErstellen />} /> */}
        {/* </StudioErstellenProvider> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
